import React from "react";
import { Row } from "@masterteam/mt-design-react";

import SummaryCard from "./SummaryCard";

import "./style.scss";

const SummaryCharts = ({
  strategy,
  thresholds,
  projectStatuses,
  systemStatuses,
  levels
}) => {
  return (
    <Row size="large" align="stretch">
      <SummaryCard
        data={
          strategy?.[
            +strategy?.StrategyType === 1 ? "KPIChart" : "KPIChartGroup"
          ]?.ChartData
        }
        detailsData={
          (+strategy?.StrategyType === 1
            ? strategy?.KPIs
            : strategy?.KPIChartGroup?.Group) || []
        }
        title={
          strategy?.StrategyType === 1
            ? "strategy-map.kpis-summary"
            : "strategy-map.objectives-summary"
        }
        detailsTitle="strategy-map.kpis-list"
        statuses={
          strategy?.StrategyType === 1
            ? thresholds?.filter((e) => e.Code !== "NA")
            : thresholds
        }
        detailsGroupedByObjectives={+strategy?.StrategyType === 2}
        totalCount={
          strategy?.[
            +strategy?.StrategyType === 1 ? "KPIChart" : "KPIChartGroup"
          ]?.Count
        }
        systemStatuses={strategy?.StrategyType === 1 ? null : systemStatuses}
      />

      <SummaryCard
        data={strategy?.LevelChart?.ChartData}
        detailsData={strategy?.Levels || []}
        title={+strategy?.StrategyType === 1 ? "strategy-map.projects-summary" : "strategy-map.initiatives-summary"}
        detailsTitle={+strategy?.StrategyType === 1 ? "strategy-map.projects-list" : "strategy-map.initiatives-list"}
        statuses={projectStatuses
          // strategy?.StrategyType === 1
          //   ? projectStatuses.filter((e) => e.Code !== "Not Started")
          //   : projectStatuses
        }
        totalCount={strategy?.LevelChart?.Count}
        isProject={+strategy?.StrategyType === 1}
        isInitiative={+strategy?.StrategyType === 2}
        levels={levels}
      />
    </Row>
  );
};

export default SummaryCharts;
